import { useContext } from "react";
import { ArtifactThemesContext } from "../../context/ArtifactsContext";
import { artifactThemeToSceneItem } from "../../helpers/transformers/scene";
import { SceneItem } from "../../models/client/scene";
import { SceneMarker } from "./SceneMarker";

interface SceneMarkerListProps {
  onMarkerMouseEnter: () => void;
  onMarkerMouseLeave: () => void;
  onMarkerClick: (item: SceneItem) => void;
}

export const SceneMarkerList: React.FC<SceneMarkerListProps> = ({
  onMarkerClick,
  onMarkerMouseEnter,
  onMarkerMouseLeave,
}) => {
  const { artifactThemes } = useContext(ArtifactThemesContext);
  return (
    <>
      {artifactThemes.map(artifactThemeToSceneItem).map((item, i) => (
        <div
          key={item.id}
          onMouseEnter={onMarkerMouseEnter}
          onMouseLeave={onMarkerMouseLeave}
          onClick={() => onMarkerClick(item)}
        >
          <SceneMarker
            id={item.id}
            position={item.position}
            color={item.btnColor}
            image={item.image}
            size={item.size}
            offsetPosition={item.offsetPosition}
          />
        </div>
      ))}
    </>
  );
};
